<!-- MIT License

Copyright (c) 2025 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->
<span class="signin">
  <h1 mat-dialog-title class="header">Quick Crypt Sign In</h1>
  <mat-progress-spinner
    class="spinner"
    mode="indeterminate"
    [style.visibility]="showProgress() ? 'visible' : 'hidden'"></mat-progress-spinner>

  <div mat-dialog-content class="dialog-content">
    <img src="/assets/passkey.svg" class="pklogo" width="65" height="68.75" />
    <p class="welcome">
      <b>Welcome Back.</b>
      Quick Crypt will request your passkey to sign in.
    </p>
    <div class="button-host">
      <button mat-raised-button (click)="onClickSignin($event)" class="button">
        <!--<mat-icon>login</mat-icon>-->
        <span>
          Sign in as
          <br />
          {{ userName }}
        </span>
      </button>
      <button mat-raised-button (click)="onClickForget($event)" class="button">
        <!--<mat-icon>vpn_key</mat-icon>-->
        <span>Sign in as a different user</span>
      </button>
    </div>
    <div [class]="noticeClass()">{{ notice() }}</div>
  </div>
</span>
